<template>
  <div class="view-publicmodels">
    <h1 class="mt-0">{{ $t("labels.exampleModels") }}</h1>

    <models-grid>
      <p v-if="publicModelsCount == 0">
        {{ $t("texts.noPublicModels") }}
      </p>
      <div class="column gap-4 column--container">
        <!-- eslint-disable prettier/prettier -->
        <model-entry
          v-for="publicModel in orderedModels"
          :key="publicModel.id"
          :model="publicModel"
          :description-visible="modelDescriptionsVisible"
          :show-modified-at="false"
          @copy="modelToDuplicate = ($event as PublicModel)"
        ></model-entry>
        <!-- eslint-enable prettier/prettier -->
      </div>

      <model-duplicate-popup
        :visible="modelToDuplicate != null"
        :model="modelToDuplicate"
        @close="modelToDuplicate = undefined"
      />
    </models-grid>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import ModelsGrid from "@manager/workspaces/ModelsGrid.vue";
import ModelEntry from "@manager/workspacemodels/ModelEntry.vue";
import ModelDuplicatePopup from "@manager/workspacemodels/ModelDuplicatePopup.vue";

import { usePublicModels } from "@/api/publicModels.store";
import { orderModels } from "@/api/modelFunctions";
import type { PublicModel } from "@/api/PublicModel";

const { publicModels, publicModelsCount, loadPublicModels } = usePublicModels();

const modelToDuplicate = ref<PublicModel>();
const orderModelsBy = "name" as const;
const modelDescriptionsVisible = true;

const orderedModels = computed(() => {
  return orderModels(
    Object.values(publicModels),
    orderModelsBy
  );
});

loadPublicModels();
</script>

<style>
.view-publicmodels {
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
}
</style>
